import { onScopeDispose } from 'vue';

export type UseDownload = {
    download: (content: BlobPart, filename: string) => void;
}

/**
 * Hand the browser a file to save, without a round trip to the server.
 */
export function useDownload(): UseDownload {
    const urls = new Set<string>();

    function revoke(url: string) {
        URL.revokeObjectURL(url);

        urls.delete(url);
    }

    onScopeDispose(() => {
        for(const url of urls) {
            revoke(url);
        }
    });

    return {
        download(content: BlobPart, filename: string) {
            const url = URL.createObjectURL(
                content instanceof Blob ? content : new Blob([content])
            );

            urls.add(url);

            const link = document.createElement('a');

            link.href = url;
            link.download = filename;
            link.style.display = 'none';

            document.body.appendChild(link);
            link.click();
            link.remove();

            // Revoking synchronously can cancel a download that has not
            // finished starting, so release the URL on the next task instead
            // of holding it — an exported CSV can be large. The scope hook
            // above only catches URLs whose timer never ran.
            setTimeout(() => revoke(url));
        }
    };
}
